import { render, staticRenderFns } from "./CustomerIcon.vue?vue&type=template&id=157bdae2&"
import script from "./CustomerIcon.vue?vue&type=script&lang=js&"
export * from "./CustomerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports